import { render, staticRenderFns } from "./AiReport.vue?vue&type=template&id=397a067e&scoped=true&"
import script from "./AiReport.vue?vue&type=script&setup=true&lang=js&"
export * from "./AiReport.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397a067e",
  null
  
)

export default component.exports